<div class="image-crop-wrapper">
	<h3>{{ data.title }}</h3>
	<mat-icon mat-dialog-close matRipple class="close-icon">close</mat-icon>
	<div class="crop-area-wrapper">
		<div
			class="crop-area"
			[ngClass]="{ 'image-not-selected': !isFileSelected }"
			(dragenter)="onDragFileEnter($event)"
			(dragleave)="onDragFileLeave($event)"
			(dragover)="allowDrop($event)"
			(drop)="handleImageDrop($event)"
			(click)="!isFileSelected && fileInput.click()"
			[class.dragover]="fileCouldBeDropped"
		>
			<input
				#fileInput
				type="file"
				accept="image/*"
				(change)="onFileChanged($event)"
				hidden
			/>

			@if (!isFileSelected) {
				<div class="upload-placeholder">
					<div class="illustration">
						<img src="./assets/img/maskot/upload-picture.svg" alt="image with maskot" />
					</div>
					<p style="white-space: pre-line; text-align: center">
						{{ 'drag_drop_photo_text' | translate }}
					</p>
				</div>
			}

			@if (isFileSelected) {
				<image-cropper
					class="au-image-cropper"
					#cropper
					[imageChangedEvent]="imageChangedEvent"
					[maintainAspectRatio]="data.isProfilePicture"
					[imageFile]="droppedImageFile"
					(imageCropped)="onImageCropped($event)"
					[resizeToWidth]="350"
					[onlyScaleDown]="true"
					[roundCropper]="data.isProfilePicture"
					[autoCrop]="false"
					[cropperMinWidth]="150"
					format="png"
				>
				</image-cropper>
			}
		</div>
	</div>

	<div class="cropper-action-buttons">
		<au-techno-btn [fullWidth]="true" (click)="close()">{{
			'cancel' | translate
		}}</au-techno-btn>
		<button
			[disabled]="!isFileSelected"
			mat-flat-button
			class="upload-btn"
			(click)="cropAndUpload()"
		>
			{{ 'save' | translate }}
		</button>
	</div>
</div>
